import * as actionType              from "./Action_Type";
import { CALL_API }                 from "../Middlewares/api";
import { sortList }                 from "../Utils/Sorting";
import * as SGUri                   from "../Utils/PagesSwitch.js";
import { SERVICE_PESATE_FILE_TYPE_LIST_CLOSE, EXPORT_FORMAT_LIST, EXPORT_PESATE, WEIGHING_GET_LIST, WEIGHING_GET_FILTER, WEIGHING_SET_FILTER, FILTER_LOGICAL_OPERATOR, WEIGHING_GET_DETAILS }        from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getListaPesate(filter) {
  var obj = {
    Cancellata     : filter.Cancellata,
    IDAziendaUno   : filter.IDAziendaUno,     
    IDAziendaDue   : filter.IDAziendaDue,
    IDImpiantoUno  : filter.IDImpiantoUno,
    IDImpiantoDue  : filter.IDImpiantoDue,
    IDBilanciaUno  : filter.IDBilanciaUno,
    IDBilanciaDue  : filter.IDBilanciaDue,
    DataInizioUno  : filter.DataInizioUno,
    DataFineUno    : filter.DataFineUno,
    DataInizioDue  : filter.DataInizioDue,
    DataFineDue    : filter.DataFineDue,
    PrimoPesoMin   : filter.PrimoPesoMin,
    PrimoPesoMax   : filter.PrimoPesoMax,
    SecondoPesoMin : filter.SecondoPesoMin,
    SecondoPesoMax : filter.SecondoPesoMax,
  }
  
  return {
    [CALL_API]: {
      endpoint: WEIGHING_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_PESATE_LIST_REQUEST,
        actionType.SERVICE_PESATE_LIST_SUCCESS,
        actionType.SERVICE_PESATE_LIST_ERROR
      ]
    }
  };
}

export function getDettaglioPesata(IDPesata) {
  return {
    [CALL_API]: {
      endpoint: WEIGHING_GET_DETAILS+SGUri.serializeParameters({IDPesata : IDPesata}),
      authenticated: true,
      types: [
        actionType.SERVICE_PESATE_DETAILS_REQUEST,
        actionType.SERVICE_PESATE_DETAILS_SUCCESS,
        actionType.SERVICE_PESATE_DETAILS_ERROR
      ]
    }
  };
}
export const dialogDetails_Close = () => dispatch => dispatch( { type : actionType.SERVICE_PESATE_DETAILS_CLOSE } );

export const orderListaPesate = (holdList, value) => {
   return dispatch => {
     dispatch(requestList(actionType.SHOW_LOADER));
     dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_PESATE_REFRESH_LIST));
   }
};
export const dialogFiltri_Close = () => dispatch => dispatch( { type : actionType.SERVICE_PESATE_DIALOG_FILTRI_CLOSE } );
export const dialogFiltri_Open  = () => dispatch => dispatch( { type : actionType.SERVICE_PESATE_DIALOG_FILTRI_OPEN } );

export const addFilter = (filtro) => { 
  var obj = {
    CampoPersonalizzato : filtro.CampoPersonalizzato,
    Filtro       : filtro.Filtro,
    Operatore    : filtro.Operatore,
    CampoTabella : filtro.CampoTabella
  };
  if(obj.CampoPersonalizzato)
    obj.CampoPersonalizzato.ID = obj.CampoPersonalizzato.IDMaster
  return dispatch => {
    dispatch({
      type : actionType.SERVICE_PESATA_ADD_FILTER,
      filtro : filtro
    })
  }
}

export const removeFilter = (index) => {
  return dispatch => {
    dispatch({
      type : actionType.SERVICE_PESATA_REMOVE_FILTER,
      index : index
    })
  }
}

export function setInternalFilter(filtri){
  return dispatch => {
    dispatch({
      type : actionType.SERVICE_PESATE_SET_FILTER,
      list : filtri
    })
  }
}

export function setFiltriPesate(filtri) {
  return {
    [CALL_API]: {
      endpoint      : WEIGHING_SET_FILTER,
      authenticated : true,
      method        : "POST",
      types         : [
        actionType.SERVICE_PESATE_SET_FILTER_REQUEST,
        actionType.SERVICE_PESATE_SET_FILTER_SUCCESS,
        actionType.SERVICE_PESATE_SET_FILTER_ERROR
      ],
      data : filtri,
    }
  };
}

export const getFiltriPesate = () => {
  return {
    [CALL_API]: {
      endpoint: WEIGHING_GET_FILTER,
      authenticated: true,
      types: [
        actionType.SERVICE_PESATE_GET_FILTER_REQUEST,
        actionType.SERVICE_PESATE_GET_FILTER_SUCCESS,
        actionType.SERVICE_PESATE_GET_FILTER_ERROR
      ]
    }
  };
}

export function getLogicalOperator(tipo) {
  return {
    [CALL_API]: {
      endpoint: FILTER_LOGICAL_OPERATOR+SGUri.serializeParameters({Tipo : tipo}),
      authenticated: true,
      types: [
        actionType.SERVICE_FILTER_LOGICAL_OPERATOR_REQUEST,
        actionType.SERVICE_FILTER_LOGICAL_OPERATOR_SUCCESS,
        actionType.SERVICE_FILTER_LOGICAL_OPERATOR_ERROR
      ]
    }
  };
}

export function getFileTypeToDownload(){
  return {
    [CALL_API]: {
      endpoint: EXPORT_FORMAT_LIST,
      authenticated: true,
      types: [
        actionType.SERVICE_PESATE_FILE_TYPE_LIST_REQUEST,
        actionType.SERVICE_PESATE_FILE_TYPE_LIST_SUCCESS,
        actionType.SERVICE_PESATE_FILE_TYPE_LIST_ERROR
      ]
    }
  };
}

export function dialogDownload_Close(){
  return dispatch => {
    dispatch({
      type : actionType.SERVICE_PESATE_FILE_TYPE_LIST_CLOSE
    })
  }
}

export function getExportDownload(params){
  debugger;
  var obj = {
    ExportFormat : params.fileTypeSelected,
    FileName     : params.FileName
  };
  return {
    [CALL_API]: {
      endpoint: EXPORT_PESATE,
      authenticated: true,
      types: [
        actionType.SERVICE_PESATE_FILE_DOWNLOAD_REQUEST,
        actionType.SERVICE_PESATE_FILE_DOWNLOAD_SUCCESS,
        actionType.SERVICE_PESATE_FILE_DOWNLOAD_ERROR
      ],
      method        : "POST",
      data          : SGUri.serializeParametersPOST(obj),
    }
  };
}

//fileDownload(data, 'filename.csv');


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Pesate.js